<div class="container">
  <div class="container-text">
    <h1>Thankyou for your request. We are working on it!</h1>
    <h3>You will be redirected to the home page when the action is completed or you can click in the button below to navigate now</h3>
    <div class="loading-layer">
      <dx-load-indicator height="100" width="100"></dx-load-indicator>
    </div>
    <div class="action-container">
      <dx-button stylingMode="contained" type="default" text="HOME PAGE" (onClick)="redirectHomePage()" class="super-user-btn"></dx-button>
    </div>
  </div>
  <div class="container-img"></div>
</div>
